import { render, staticRenderFns } from "./X431mr.vue?vue&type=template&id=1a37c0f1&scoped=true&"
import script from "./X431mr.vue?vue&type=script&lang=js&"
export * from "./X431mr.vue?vue&type=script&lang=js&"
import style0 from "./X431mr.vue?vue&type=style&index=0&id=1a37c0f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a37c0f1",
  null
  
)

export default component.exports